import { useEffect, useState } from "react";
import { useUserAuthStore } from "../../context/useUserAuthStore";
import { useBookingsStore } from "../../context/useBookingsStore";

import BookingCreateModal from "../bookings/BookingCreateModal";
import BookingCheckoutModal from "../bookings/BookingCheckoutModal";
import BookingReturnModal from "../bookings/BookingReturnModal";
import BookingsTable from "../bookings/BookingsTable";

export default function BookingsTab() {
  const { currentUser } = useUserAuthStore();
  const {
    bookings,
    fetchBookings,
    loading,
    error,
  } = useBookingsStore();

  const isAdmin = currentUser?.role === "admin";

  const [showCreate, setShowCreate] = useState(false);
  const [checkoutBooking, setCheckoutBooking] = useState(null);
  const [returnBooking, setReturnBooking] = useState(null);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Bookings</h2>

        {/* Drivers & admins can request */}
        <button
          className="bg-blue-600 text-white px-3 py-1.5 rounded text-sm"
          onClick={() => setShowCreate(true)}
        >
          + Request Booking
        </button>
      </div>

      {loading && <div>Loading bookings...</div>}
      {error && <div className="text-red-600">{error}</div>}

      {!loading && (
        <BookingsTable
          bookings={bookings}
          isAdmin={isAdmin}
          currentUser={currentUser}
          onCheckout={setCheckoutBooking}
          onReturn={setReturnBooking}
        />
      )}

      {/* Create */}
      {showCreate && (
        <BookingCreateModal
          onClose={() => setShowCreate(false)}
          onDone={() => {
            setShowCreate(false);
            fetchBookings();
          }}
        />
      )}

      {/* Checkout */}
      {checkoutBooking && (
        <BookingCheckoutModal
          booking={checkoutBooking}
          onClose={() => setCheckoutBooking(null)}
          onDone={() => {
            setCheckoutBooking(null);
            fetchBookings();
          }}
        />
      )}

      {/* Return */}
      {returnBooking && (
        <BookingReturnModal
          booking={returnBooking}
          onClose={() => setReturnBooking(null)}
          onDone={() => {
            setReturnBooking(null);
            fetchBookings();
          }}
        />
      )}
    </div>
  );
}
